/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_UsersInputs */

const vi_nav_users = /** @type {(inputs: Nav_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người dùng`)
};

/**

* @param {Nav_UsersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_users = /** @type {((inputs?: Nav_UsersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_UsersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_users(inputs)
});